@if (isLoading) {
  <div class="grid grid-cols-2 gap-3">
    <vw-skeleton-loader [width]="'100%'" [height]="'130px'" [borderRadius]="'1rem'"></vw-skeleton-loader>
    <vw-skeleton-loader [width]="'100%'" [height]="'130px'" [borderRadius]="'1rem'"></vw-skeleton-loader>
  </div>
} @else if (hasContent) {
  <!-- Deux tuiles, deux destinations. La carte dépliable d'avant demandait un
       geste pour ne rien montrer de plus qu'un thermomètre, puis un second
       geste sur l'une des deux rangées d'action. Ici le premier geste ouvre
       directement la page.

       Le chevron n'est pas décoratif : c'est le signal de navigation déjà
       établi par les bandeaux de l'accueil juste en dessous. Sans lui, une
       tuile colorée se lit comme un panneau d'affichage. -->
  <div class="grid grid-cols-2 gap-3">
    <button
      type="button"
      (click)="openWeather()"
      class="flex aspect-[4/3] flex-col justify-between overflow-hidden rounded-2xl p-3 text-left shadow-sm transition active:scale-[0.98]"
      [style.background-color]="backgroundColor | HexToHsl"
      [attr.aria-label]="'home.tiles.weather' | translate"
    >
      <div class="flex items-center justify-between gap-1">
        <span class="text-[10px] font-semibold uppercase tracking-wide text-[#451a03]/60">
          {{ 'home.tiles.weather' | translate }}
        </span>
        <!-- Chevron en ligne et non `vw-chevron-right-icon` : ce composant est
             figé à 24 px, taille juste pour les bandeaux pleine largeur, deux
             fois trop grosse pour l'en-tête d'une tuile. -->
        <svg viewBox="0 0 24 24" class="h-[18px] w-[18px] shrink-0 text-[#451a03]/70" fill="none" aria-hidden="true">
          <path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      @if (currentWeather) {
        <!-- L'illustration à côté du chiffre, pas au-dessus : la tuile gagne
             les quarante pixels de hauteur qui la faisaient paraître lourde. -->
        <div class="flex items-center gap-1.5">
          @if (iconUrl) {
            <vw-icon-svg [iconUrl]="iconUrl" width="38" height="38"></vw-icon-svg>
          }
          <p class="text-[26px] font-semibold leading-none text-[#451a03]">
            {{ currentWeather.currentTemperature }}<span class="text-sm">°c</span>
          </p>
        </div>

        <!-- Le mini et le maxi du jour : la valeur du moment ne dit ni si la
             nuit sera froide, ni jusqu'où l'après-midi monte. -->
        <div class="flex items-center gap-2 text-[11px] text-[#451a03]/80">
          <span class="flex items-center gap-0.5">
            <vw-icon-svg iconUrl="/assets/svg/weather/weather-arrow-up.svg" width="12" height="12"></vw-icon-svg>
            {{ currentWeather.maxTemperature }}°
          </span>
          <span class="flex items-center gap-0.5">
            <vw-icon-svg iconUrl="/assets/svg/weather/weather-arrow-down.svg" width="12" height="12"></vw-icon-svg>
            {{ currentWeather.minTemperature }}°
          </span>
          @if (currentWeather.totalPrecipitation) {
            <span class="flex items-center gap-0.5">
              <vw-icon-svg iconUrl="/assets/svg/weather/weather-droplet.svg" width="12" height="12"></vw-icon-svg>
              {{ currentWeather.totalPrecipitation }}mm
            </span>
          }
        </div>

        <!-- L'alerte du jour : la seule ligne de la tuile qui demande un geste. -->
        @if (weatherTriggers.length) {
          <span
            class="block w-full truncate rounded-full px-2 py-0.5 text-[10px] font-semibold"
            [style.background-color]="chipStyle(weatherTriggers[0].trigger).background"
            [style.color]="chipStyle(weatherTriggers[0].trigger).ink"
          >
            {{ chipStyle(weatherTriggers[0].trigger).emoji }}
            {{ 'home.garden-today.tags.' + weatherTriggers[0].trigger | translate }}
          </span>
        }
      }
    </button>

    <!-- La tuile lunaire, revenue à l'accueil : elle avait disparu derrière un
         dépliement, alors qu'elle porte le jour feuille / racine, qui change
         chaque jour et oriente le geste. -->
    <button
      type="button"
      (click)="openLunar()"
      class="flex aspect-[4/3] flex-col justify-between overflow-hidden rounded-2xl bg-[#261E77] p-3 text-left shadow-sm transition active:scale-[0.98]"
      [attr.aria-label]="'home.tiles.moon' | translate"
    >
      <div class="flex items-center justify-between gap-1">
        <span class="text-[10px] font-semibold uppercase tracking-wide text-white/50">
          {{ 'home.tiles.moon' | translate }}
        </span>
        <svg viewBox="0 0 24 24" class="h-[18px] w-[18px] shrink-0 text-white/60" fill="none" aria-hidden="true">
          <path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      <div class="flex items-center gap-2">
        <span class="shrink-0 text-[30px] leading-none">{{ moonGlyph }}</span>
        @if (lunar) {
          <p class="min-w-0 text-[15px] font-semibold leading-tight text-white">
            {{ 'home.lunar.influence.' + lunar.influence | translate }}
          </p>
        }
      </div>

      <div class="min-w-0">
        @if (moonData) {
          <p class="truncate text-[11px] text-white/70">
            {{ 'home.weather.moon.phases.' + moonData.moonPhase | translate }}
          </p>
        }
        @if (lunar) {
          <p class="mt-0.5 truncate text-[11px] text-white/70">
            {{ moonPathIcon }} {{ 'home.lunar.moonPath.' + lunar.moonPath | translate }}
          </p>
        }
      </div>
    </button>
  </div>
}
